import * as React from "react";
import { forwardRef } from "react";
const SvgArrowDown = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentcolor", d: "m8.416 10.763 4.747-4.746a.58.58 0 0 0 .17-.413.58.58 0 0 0-.17-.413l-.35-.35a.584.584 0 0 0-.825 0L8.002 8.829l-3.99-3.99a.58.58 0 0 0-.413-.171.58.58 0 0 0-.413.17l-.349.35a.58.58 0 0 0-.17.413c0 .156.06.302.17.412l4.751 4.751c.11.11.257.17.414.17a.58.58 0 0 0 .414-.17" }));
const ForwardRef = forwardRef(SvgArrowDown);
export default ForwardRef;
